import { render, staticRenderFns } from "./ThreeCols.vue?vue&type=template&id=153ce03f&scoped=true&"
import script from "./ThreeCols.vue?vue&type=script&lang=js&"
export * from "./ThreeCols.vue?vue&type=script&lang=js&"
import style0 from "./ThreeCols.vue?vue&type=style&index=0&id=153ce03f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153ce03f",
  null
  
)

export default component.exports